import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MessageSquareIcon, ArrowRightIcon } from 'lucide-react';
export function ContactSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-[#0C1B26] to-[#212C34]" data-id="element-165">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="max-w-4xl mx-auto text-center" data-id="element-167">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-168">
            <MessageSquareIcon size={40} className="text-[#0DC3DC]" data-id="element-169" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-170">
            Ready to Start Your Project?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-white/90 mb-8" data-id="element-171">
            Get in touch today for a free consultation and quote. We'll respond
            within 24 hours.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-172">
            <Link to="/contact" className="inline-flex items-center justify-center bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-white px-8 py-4 rounded-lg font-bold transition-colors shadow-lg text-lg" data-id="element-173">
              Get Your Free Quote
              <ArrowRightIcon size={20} className="ml-2" data-id="element-174" />
            </Link>
            <a href="mailto:info@bright-pixxel.com" className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#0C1B26] px-8 py-4 rounded-lg font-bold transition-colors text-lg" data-id="element-175">
              Email Us Directly
            </a>
          </motion.div>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-sm text-white/70 mt-6" data-id="element-176">
            ✓ Fast response times ✓ Transparent pricing ✓ 100% site ownership
          </motion.p>
        </div>
      </div>
    </section>;
}